"use client";

import React, { FormEvent, useState } from "react";
import CustomInput from "../form/CustomInput";
import { Button } from "../button";
import { useTranslations } from "next-intl";
import { usePathname, useRouter, useSearchParams } from "next/navigation";

const GlobalPageSearch = () => {
  const t = useTranslations();
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();
  const [search, setSearch] = useState("");

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const params = new URLSearchParams(searchParams.toString());

    if (search.trim()) {
      params.delete("filter");
      params.delete("sort");

      params.set("search", search.trim());
    } else params.delete("search");

    params.set("page", "1");
    params.set("limit", "8");

    router.push(`${pathname}?${params.toString()}`);
    setSearch("");
  };

  return (
    <form onSubmit={handleSubmit} className="flex items-center w-full gap-2">
      <CustomInput
        name="search"
        type="search"
        value={search}
        placeholder="Search by title or description or technologies"
        className="w-full h-[48px]"
        onChange={(e) => setSearch(e.target.value)}
      />
      <Button type="submit" className="h-10 lg:h-[48px]">
        {t("Search")}
      </Button>
    </form>
  );
};

export default GlobalPageSearch;
